import React from 'react';
import { renderDate, renderQuotaUsage } from '../../helpers/HelperMethods';
import InfoTooltip from '../formFields/InfoTooltip';

const SiteStatistics = ({statistics}) => {
    
    // const onBoolRender = (value) => {
    //     return value ? 'Yes' : 'No';
    // }

    const onAppendTextRender = (append) => (value) => {
        return `${value} ${append}`;
    }

    const renderField = (label, value, onRender, tooltip) => {
        const tooltipHost = tooltip && <InfoTooltip content={tooltip} />
        return  <div style={renderFieldtyles}>
                    <span style={fieldLabelStyles}>{label}{tooltipHost}</span>
                    <span>{onRender ? onRender(value) : value}</span>
                </div>
    }

    return (
        <div style={formStyles}>
            {renderField('Report Refresh Date', statistics.reportRefreshDate, renderDate)}
            {renderField('Last Activity Date', statistics.lastActivityDate, renderDate, 'The date of the last time file activity was detected or a page was viewed on the site.')}
            {renderField('File Count', statistics.fileCount, null, 'The number of files on the site.')}
            {renderField('Active File Count', statistics.activeFileCount, null, 'A file is considered active if it has been saved, synced, modified, or shared within the specified time period.')}
            {renderField('Page View Count', statistics.pageViewCount, null, 'The number of times pages were viewed on the site.')}
            {renderField('Visited Page Count', statistics.visitedPageCount, null, 'The number of unique pages that were visited on the site.')}
            {renderField('Quota Usage', renderQuotaUsage(null, statistics.storageAllocatedGB, statistics.storageUsedMB))}
            {renderField('Quota Allocated', statistics.storageAllocatedGB, onAppendTextRender('GB'))}
            {renderField('Root Web Template', statistics.rootWebTemplate)}
            {renderField('Report Period', statistics.reportPeriodDays, onAppendTextRender('days'))}
        </div>
    )
}

const formStyles = {
}

const renderFieldtyles = {
    margin: 20,
    display: 'flex',
    justifyContent: 'space-between',
}

const fieldLabelStyles = {
    fontWeight: 'bold'
}

export default SiteStatistics


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteStatistics.js